import cookie from 'browser-cookies';

export const isOpenBetSessionProxyModeEnabled = () => {
  return cookie.get('wh-ob-session-proxy-mode-enabled') !== null;
};
